import { useEffect } from 'react';
import { collectDeviceSettings } from './collectDeviceSettings';
import { recordDeviceSettings } from './deviceSettingsApi';

const SESSION_KEY_PREFIX = 'endchess-device-recorded:';

function sessionStorageKey(userId: string): string {
  return `${SESSION_KEY_PREFIX}${userId}`;
}

function hasRecordedThisSession(userId: string): boolean {
  try {
    return sessionStorage.getItem(sessionStorageKey(userId)) === '1';
  } catch {
    return false;
  }
}

function markRecordedThisSession(userId: string): void {
  try {
    sessionStorage.setItem(sessionStorageKey(userId), '1');
  } catch {
    // Ignore quota / privacy mode errors.
  }
}

export function useRecordDeviceSettings(
  userId: string | undefined,
  authChecked: boolean,
): void {
  useEffect(() => {
    if (!authChecked || !userId || hasRecordedThisSession(userId)) {
      return;
    }

    markRecordedThisSession(userId);

    void recordDeviceSettings(collectDeviceSettings()).catch(() => {
      try {
        sessionStorage.removeItem(sessionStorageKey(userId));
      } catch {
        // Ignore.
      }
    });
  }, [authChecked, userId]);
}
